<script>
    import Login from "./inicio/login.svelte";
    import Ficha from "./ficha.svelte";
    import { usucon, sto_cliente_web } from "../store";

    console.log('redirect_url:', $sto_cliente_web.redirect_url)
    console.log('state:', $sto_cliente_web.state)
    let opcion = 1;
</script>

{#if opcion == 1}
    <Login on:validado={() => (opcion = 2)} />
{/if}

{#if opcion == 2}
    <Ficha
        origen="graduado"
        graduadoId={$usucon.tokenUsuario}
        on:volver={() => (opcion = 1)}
    />
{/if}
